module.exports = __webpack_public_path__ + "img/ic_challenges_empty.1e6d8974.svg";